/* 關張傳・第 4 章：襄樊・水淹七軍（建安二十四年，219）
 * 史實：《三國志·關羽傳》「是歲，羽率眾攻曹仁於樊。曹公遣于禁助仁。秋，大霖雨，漢水汎溢，禁所督七軍皆沒。禁降羽，羽又斬將軍龐德。」
 *       《于禁傳》「秋，大霖雨，漢水溢，平地水數丈，禁等七軍皆沒。禁與諸將登高望水，無所回避，羽乘大船就攻禁等，禁遂降，惟龐德不屈節而死。」
 *       《龐德傳》「後親與羽交戰，射羽中額。時德常乘白馬，羽軍謂之白馬將軍，皆憚之。仁使德屯樊北十里，會天霖雨十餘日，漢水暴溢，
 *       樊下平地五六丈，德與諸將避水上堤。羽乘船攻之，以大船四面射堤上。德被甲持弓，箭不虛發。將軍董衡、部曲將董超等欲降，德皆收斬之。
 *       自平旦力戰至日過中，羽攻益急，矢盡，短兵接戰。……而水浸盛，吏士皆降。德與麾下將一人，五伯二人，彎弓傅矢，乘小船欲還仁營。
 *       水盛船覆，失弓矢，獨抱船覆水中，為羽所得，立而不跪。……遂為羽所殺。」
 * 流程：1. 白馬將軍：龐德帶兵出營挑戰，自己在後面放箭（地上先畫一條線）；被射中就是「中額」。把出來的兵打退。
 *       2. 大霖雨：到江邊上大船。漢水漫上平地，七軍的營地沒在水裡，兵往小丘上逃。
 *       3. 登高望水：大船開到小丘旁停住，船上弓手四面放箭（停船才射）；壓力滿了于禁投降。
 *       4. 箭不虛發：龐德在堤上朝船射箭（紅線預告），箭有數。大船停著才射得到堤上；射完了矢盡、堤上的兵投降。
 *       5. 水盛船覆：龐德乘小船往樊城逃，船翻了抱船漂在水裡。追上去停在他旁邊擒住。讓他漂回樊城就失敗。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, hero, rout, vanish, TROOPS } from '../kit.ts';
import { GZ, spare, hold, calm, rain } from './guanzhang_kit.ts';
import { CAMP, DOCK, BOAT0, BAND, DYKE, HILL, FLEE } from '../maps/guanzhang_fan.ts';

const LV = 16, ARROWS = 12, CAMPS = [[2100, 2700], [2200, 3600], [3000, 3000], [3300, 3650], [4500, 3050], [4700, 3600], [5100, 2700]];
const WEI = { spec: TROOPS.wei, name: '魏兵', hp: 500, maxHp: 500, atk: 28 };
const inEl = (x, y, e) => ((x - e[0]) / e[2]) ** 2 + ((y - e[1]) / e[3]) ** 2 < 1;
const onDyke = (x, y) => Math.abs(x - DYKE[0]) < DYKE[2] && Math.abs(y - DYKE[1]) < DYKE[3] + 60;

export default {
  id: 'guanzhang-4', map: 'guanzhang_fan', hero: 'guanyu',
  title: '第 4 章　襄樊・水淹七軍', year: '建安二十四年（219）',
  brief: {
    quote: [{ text: '秋，大霖雨，漢水汎溢，禁所督七軍皆沒。禁降羽，羽又斬將軍龐德。', src: '《三國志·蜀書·關羽傳》' }],
    text: '劉備取漢中，自立為漢中王，拜關羽為前將軍、假節鉞。同年關羽率眾北攻樊城的曹仁，曹操派于禁督七軍來救，龐德為先鋒，屯在樊城北邊。',
    goals: ['白馬將軍：打退龐德的出營挑戰，小心他的箭', '大霖雨：上大船', '逼于禁投降', '堤上的龐德：等他矢盡', '追上龐德的小船'],
  },
  words: { ally: '舟兵', foe: '魏兵' },
  lowland(m, x, y) { return x > BAND[0] && x < BAND[1] && y > BAND[2] && y < BAND[3] && !inEl(x, y, HILL) && !onDyke(x, y) && SG.MAP.walkable(x, y, 0) && !SG.MAP.waterAt(x, y); },
  sail(m, x, y) { return m.flooded(x, y); },
  stars: [
    { text: '白馬將軍的箭一支都沒射中你', ok: (m) => !m.vars.forehead },
    { text: '漢水暴溢後 90 秒內于禁投降', ok: (m) => m.vars.yuT != null && m.vars.yuT < 90 },
    { text: '大船被龐德射中不超過 3 次', ok: (m) => (m.vars.hits || 0) <= 3 },
  ],
  steps: [
    { // 0. 白馬將軍
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMP[0] + 500; me.y = CAMP[1];
        V.ping = ally(w, GZ.guanping, me.x - 80, me.y + 90, LV - 2);
        V.pd = boss(w, hero('pangde'), 3300, 3100, { name: '龐德', hp: 5200, atk: 48, armor: 9, ms: 240 });
        V.pd.home = [3300, 3100];
        spare(w, V.pd, (u) => { u.hp = u.maxHp * 0.3; u.subdued = false; retreat(m, w); }); // 這一戰打不死：退回營裡
        V.sortie = Array.from({ length: 9 }, (_, i) => { const u = m.foe('huangjin', 2900 + (i % 3) * 90, 3000 + Math.floor(i / 3) * 110, WEI); u.home = [me.x + 100, me.y]; return u; });
        V.arrowT = 3;
        m.line('關羽', '那個騎白馬的，就是龐德？');
        m.after(2.5, () => m.line('龐德', '我受國恩，義在效死。今年我不殺羽，羽當殺我！'));
        m.after(5.5, () => m.line('提示', '龐德在後面放箭：地上先畫出一條線，快離開那條線。'));
        m.obj('sortie', '打退龐德的出營挑戰');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        if (!V.pd.gone) { // 白馬將軍不上前，站在後面放箭
          V.pd.target = null; V.pd.think = 0.5;
          if ((V.arrowT -= dt) <= 0 && me.alive && SG.gd(me.x, me.y, V.pd.x, V.pd.y) < 1300) { V.arrowT = 2.4; shoot(m, w, V.pd, me, 150, () => { V.forehead = true; m.line('關羽', '……！（額上中了一箭）'); }); }
        }
        return !V.sortie.some((u) => u.alive);
      },
    },
    { // 1. 大霖雨
      enter(m, w) {
        const V = m.vars;
        m.done('sortie');
        if (!V.pd.gone) retreat(m, w);
        m.card('時德常乘白馬，羽軍謂之白馬將軍，皆憚之。', '《龐德傳》');
        m.after(4, () => { V.rain = 1; m.card('會天霖雨十餘日，漢水暴溢，樊下平地五六丈。', '《龐德傳》'); });
        m.after(7, () => m.line('關羽', '漢水要漲了。上船！'));
        // 七軍：平地上的營
        V.seven = [];
        CAMPS.forEach(([x, y], k) => { for (let i = 0; i < 3; i++) { const u = m.foe('huangjin', x + (i - 1) * 80, y + (i % 2) * 60, WEI); u.camp = k; u.asleep = true; u.untargetable = true; V.seven.push(u); } });
        V.yu = boss(w, hero('yujin'), HILL[0], HILL[1] - 40, { name: '于禁', hp: 4000, atk: 40, armor: 9 });
        hold(V.yu); spare(w, V.yu, () => {});
        m.mark('dock', DOCK[0], DOCK[1], '碼頭');
        m.obj('dock', '到江邊上大船');
      },
      tick(m, w) { return m.near(w.player, DOCK[0], DOCK[1], 160); },
    },
    { // 2. 漢水汎溢：上船，水淹七軍
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('dock'); m.unmark('dock');
        me.x = BOAT0[0]; me.y = BOAT0[1];
        V.ping.hold = null; V.ping.x = BOAT0[0] - 60; V.ping.y = BOAT0[1];
        V.b = m.boat(me, { x: BOAT0[0], y: BOAT0[1], sp: 210, big: true, crew: [V.ping], flag: '#3e7b50' });
        V.t2 = w.t;
        for (let x = BAND[0] + 40; x < BAND[1]; x += 80) m.flood(x, BAND[3] - 30); // 從南岸漫上來
        m.big('漢水暴溢！');
        m.after(2, () => m.line('提示', '大船：右鍵點哪裡就往哪裡划，水淹到的地方都划得過去。船停著，船上的弓手才會放箭。'));
        m.mark('hill', HILL[0], HILL[1], '于禁');
        m.obj('yu', '乘大船就攻于禁（船停在小丘旁）');
      },
      tick(m, w, dt) {
        const V = m.vars, b = V.b;
        if (!V.sunk && m.fires.size > 260) { V.sunk = true; m.card('平地水數丈，禁等七軍皆沒。禁與諸將登高望水，無所回避。', '《于禁傳》'); }
        V.yuP = V.yuP || 0;
        if (volley(m, w, dt, (u) => SG.gd(u.x, u.y, HILL[0], HILL[1]) < 420, SG.gd(b.x, b.y, HILL[0], HILL[1]) < 520)) { V.yuP += 12; m.line('魏兵', ['船上有箭！', '無處可躲啊！', '將軍，降了吧……'][Math.floor(SG.rand() * 3)]); }
        m.get('yu').text = `乘大船就攻于禁（船停在小丘旁；于禁的鬥志 ${Math.max(0, 100 - Math.round(V.yuP))}%）`;
        return V.yuP >= 100;
      },
    },
    { // 3. 禁遂降；堤上的龐德
      enter(m, w) {
        const V = m.vars;
        V.yuT = w.t - V.t2;
        m.done('yu'); m.unmark('hill');
        m.card('羽乘大船就攻禁等，禁遂降。', '《于禁傳》');
        rout(m, w, [V.yu, ...V.seven.filter((u) => SG.gd(u.x, u.y, HILL[0], HILL[1]) < 600)], [HILL[0], HILL[1]]);
        // 龐德與諸將避水上堤
        V.pd.gone = false; V.pd.untargetable = false; V.pd.x = DYKE[0]; V.pd.y = DYKE[1]; V.pd.home = [DYKE[0], DYKE[1]]; V.pd.hp = V.pd.maxHp; V.pd.st.stun = 0;
        spare(w, V.pd, (u) => { u.hp = 1; u.untargetable = true; });
        V.dyke = Array.from({ length: 8 }, (_, i) => { const u = m.foe('huangjin', DYKE[0] - 420 + i * 120, DYKE[1] + (i % 2 ? 30 : -30), WEI); u.home = [u.x, u.y]; return u; });
        V.arrows = ARROWS; V.arrowT = 2; V.hits = 0;
        m.after(2, () => m.line('龐德', '良將不怯死以苟免，烈士不毀節以求生。今日，我死日也！'));
        m.after(10, () => { m.line('董衡', '……龐將軍，不如降了吧。'); m.after(2, () => m.line('龐德', '欲降者，斬！')); });
        m.mark('dyke', DYKE[0], DYKE[1], '龐德');
        m.obj('pd', '以大船四面射堤上');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, b = V.b;
        if (V.arrows > 0 && (V.arrowT -= dt) <= 0 && SG.gd(b.x, b.y, V.pd.x, V.pd.y) < 1400) {
          V.arrowT = 2.6; V.arrows--;
          shoot(m, w, V.pd, me, 140, () => { V.hits++; }, 90);
          if (!V.arrows) { m.big('龐德矢盡！'); m.card('自平旦力戰至日過中，羽攻益急，矢盡，短兵接戰。', '《龐德傳》'); }
        }
        for (const u of [V.pd, ...V.dyke]) if (u.alive) { u.target = null; u.think = 0.5; } // 避水上堤：水深，下不了堤
        volley(m, w, dt, (u) => onDyke(u.x, u.y));
        const left = V.dyke.filter((u) => u.alive).length;
        m.get('pd').text = V.arrows ? `以大船四面射堤上（龐德還有 ${V.arrows} 支箭，堤上 ${left} 人）` : `矢盡：射散堤上的兵（還有 ${left} 人）`;
        return !V.arrows && left <= 2;
      },
    },
    { // 4. 水盛船覆
      enter(m, w) {
        const V = m.vars;
        m.done('pd');
        m.card('而水浸盛，吏士皆降。德與麾下將一人，五伯二人，彎弓傅矢，乘小船欲還仁營。', '《龐德傳》');
        rout(m, w, V.dyke, [DYKE[0], DYKE[1] - 300]);
        const p = SG.MAP.nearestFree(DYKE[0] + DYKE[2] + 80, DYKE[1] + 160);
        V.pd.untargetable = true; V.pd.target = null; V.pd.x = p[0]; V.pd.y = p[1];
        V.pb = m.boat(V.pd, { x: p[0], y: p[1], sp: 120, small: true, goal: FLEE.slice(), flag: '#3b5a99' });
        V.t4 = w.t;
        m.mark('pd', V.pd.x, V.pd.y, '龐德的小船', false, V.pd);
        m.obj('chase', '追上龐德，別讓他回到樊城');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, pd = V.pd, b = V.b;
        if (!V.capsized && (w.t - V.t4 > 9 || SG.gd(b.x, b.y, pd.x, pd.y) < 260)) {
          V.capsized = true; m.unboat(V.pb); hold(pd); pd.st.stun = 999;
          m.big('小船翻了！'); m.card('水盛船覆，失弓矢，獨抱船覆水中。', '《龐德傳》');
        }
        if (V.capsized && !V.got) { // 抱著翻覆的船漂向樊城
          const dx = FLEE[0] - pd.x, dy = FLEE[1] - pd.y, L = Math.hypot(dx, dy);
          if (L > 4 && !me.chan) { pd.x += (dx / L) * 28 * dt; pd.y += (dy / L) * 28 * dt; } // 撈的時候抓住了，不再漂
          if (!me.chan && b.still > 0.2 && SG.gd(b.x, b.y, pd.x, pd.y) < 260) m.chan(me, 1.5, '撈起龐德', () => { V.got = true; }, { hurt: false }); // 船停在他旁邊才撈得到；一划船就斷
        }
        if (SG.gd(pd.x, pd.y, FLEE[0], FLEE[1]) < 60 && !V.got) { m.lose('龐德逃回了樊城'); return false; }
        return !!V.got;
      },
    },
    { // 5. 立而不跪
      enter(m, w) {
        const V = m.vars;
        m.done('chase'); m.unmark('pd');
        m.card('為羽所得，立而不跪。', '《龐德傳》');
        m.after(3, () => m.line('關羽', '卿兄在漢中，我欲以卿為將，不早降何為？'));
        m.after(7, () => m.line('龐德', '豎子，何謂降也！我寧為國家鬼，不為賊將也。'));
        m.after(11, () => { m.card('遂為羽所殺。……羽威震華夏。', '《龐德傳》、《關羽傳》'); vanish(w, V.pd); });
        m.after(16, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w, dt) {
    const V = m.vars;
    if (!w.player.alive) { m.lose('關羽陣亡'); return; }
    calm(w);
    if (V.ping && !V.ping.boat) allyTick(w, V.ping, w.player);
    if (V.yu) { V.yu.target = null; }
    // 七軍：營地淹了就往小丘上逃；離小丘太遠的沒在水裡
    if (V.seven) for (const u of V.seven) {
      if (!u.alive || u.rout) continue;
      u.target = null; u.think = 0.5;
      if (!u.fled && m.flooded(u.x, u.y)) {
        if (SG.gd(u.x, u.y, HILL[0], HILL[1]) < 1500) { u.fled = true; u.home = [HILL[0] + (SG.rand() - 0.5) * 300, HILL[1] + (SG.rand() - 0.5) * 160]; u.untargetable = false; }
        else { u.alive = false; u.counted = true; w.fx({ k: 'puff', x: u.x, y: u.y }); }
      }
    }
  },
  overlay(ctx, m, view, x0, y0, vw, vh) { if (m.vars.rain) rain(ctx, view, x0, y0, vw, vh, m.vars.rain); },
};
// 龐德的箭：從他射向 t（先畫一條紅線，延長一段），hit() 是射中主角時
function shoot(m, w, from, t, dmg, hit, wid = 70) {
  const dx = t.x - from.x, dy = t.y - from.y, L = Math.hypot(dx, dy) || 1, ex = t.x + (dx / L) * 220, ey = t.y + (dy / L) * 220;
  m.warn({ x1: from.x, y1: from.y, x2: ex, y2: ey, w: wid, t: 1.1, col: '#ff5040', fn: (us) => { for (const u of us) if (u.team === 0) { m.hurt(u, dmg, 1, { stagger: 0.2 }); if (u === w.player) hit(); } } });
}
// 船上的弓手：大船停著（0.4 秒以上）每 1.5 秒放一輪，打 pick 選中的敵人；回傳這一輪有沒有射（at：沒人可打也照射，例如對著小丘）
function volley(m, w, dt, pick, at) {
  const V = m.vars, b = V.b;
  V.volT = (V.volT || 0) - dt;
  if (!b || b.still < 0.4 || V.volT > 0) return false;
  const hit = w.units.filter((u) => u.alive && u.team === 1 && !u.untargetable && SG.gd(u.x, u.y, b.x, b.y) < 560 && pick(u));
  if (!hit.length && !at) return false;
  V.volT = 1.5;
  if (at && !hit.length) w.fx({ k: 'boom', x: HILL[0], y: HILL[1], r: 160, col: '#c8a060' });
  for (const u of hit) { m.hurt(u, u.kind === 'creep' && u.caster ? 120 : 80, 0); w.fx({ k: 'puff', x: u.x, y: u.y - 30 }); }
  return true;
}
function retreat(m, w) {
  const V = m.vars;
  V.pd.gone = true; V.pd.untargetable = true; V.pd.target = null; V.pd.home = [DYKE[0], DYKE[1]];
  m.line('龐德', '……收兵！');
}
